import { useCallback, useMemo, useState } from "react";
import { Button, Spinner } from "reactstrap";
import { useFormContext } from "react-hook-form";

import DropDownSelectFromList from "../../../CommonElements/DropDownSelectFromList";
import {
  getDropdownOptions,
  checkGroups,
} from "../../../static/brands_wholesalers_data";
import { toast } from "react-toastify";
import NAIMAGE from "../../../static/NA.png";
import { useParams } from "react-router-dom";

const EditBrandFormFieldColumn = ({ brand, column }) => {
  const { type } = useParams();

  console.log("type", type);
  const [openDropDown, setOpenDropDown] = useState(false);
  const { watch, setValue, getValues } = useFormContext();

  // Watch all values at once to avoid multiple watch calls
  const formValues = watch();
  const data = formValues[column.field];
  const target_group = formValues["target_group"];
  const group = checkGroups(target_group);

  // Get main value using a more stable approach
  const getMainFieldName = () => {
    switch (column.field) {
      case "age":
        return "main_age";
      case "target_group":
        return "main_target_group";
      case "style":
        return "main_style";
      case "product_category":
        return "main_category";
      default:
        return null;
    }
  };

  const mainFieldName = getMainFieldName();
  const currentMainValue = mainFieldName ? formValues[mainFieldName] : null;

  const _handleAdd = (value) => {
    if (
      column.title === "Eco Friendly" ||
      column.title === "Size" ||
      column.title === "Brand Rating" ||
      column.title === "Brand Rating (+2)" ||
      column.title === "Brand Awareness" ||
      column.title === "Location" ||
      column.title === "Ecom Rating" ||
      column.title === "POS Rating" ||
      column.title === "Market Diversity" ||
      column.title === "Retailer Awareness" ||
      column.title === "Price Point"
    ) {
      return setValue(column.field, [value]);
    }

    if (data?.find((d) => d.id === value.id)) {
      toast.info("Already added");
      setOpenDropDown(false);
      return;
    }

    setValue(column.field, [...(data ? data : []), value]);
    setOpenDropDown(false);
  };

  const _handleDelete = (id) => {
    // Get current values directly from form state
    const currentValues = getValues();
    const currentData = currentValues[column.field];
    const currentMain = mainFieldName ? currentValues[mainFieldName] : null;

    // Find the item being deleted
    const itemToDelete = currentData.find((d) => d.id === id);

    // Filter out the deleted item
    const updatedData = currentData.filter((d) => d.id !== id);

    // Update the field with filtered data
    setValue(column.field, updatedData);

    // Only clear the main value if the deleted item WAS the main value
    // AND the main value no longer exists in the updated data
    if (currentMain && itemToDelete?.label === currentMain) {
      const mainStillExists = updatedData.some(
        (item) => item.label === currentMain
      );

      if (!mainStillExists && mainFieldName) {
        setValue(mainFieldName, "");
      }
    }
  };

  // Memoize the sorted data to prevent unnecessary re-sorts
  const sortedData = useMemo(() => {
    if (!data?.length) return [];

    return [...data].sort((a, b) => {
      if (!currentMainValue) return 0;
      return a?.label === currentMainValue
        ? -1
        : b?.label === currentMainValue
          ? 1
          : 0;
    });
  }, [data, currentMainValue]);

  const handleSetMain = useCallback(
    (itemLabel) => {
      if (mainFieldName) {
        setValue(mainFieldName, itemLabel);
      }
    },
    [mainFieldName, setValue]
  );

  return (
    <div className="flex-column align-items-center text-center p-2" style={{ flex: 1, minWidth: 150 }}>
      <h5
        className="text-center mt-2"
        style={{ fontSize: "18px", height: "50px", fontWeight: 500 }}
      >
        {column.title}
      </h5>
      {sortedData?.length > 0 ? (
        sortedData.map((item, i) => {
          const isMain = item?.label === currentMainValue;

          const image =
            group === "All"
              ? data?.find((a) => a?.label === "All ages")?.imageWhite
              : group === "Men"
                ? item?.imageWhite
                : group === "Women"
                  ? item?.imageWomenWhite
                  : group === "Men/Women"
                    ? item?.imageBothWhite
                    : item?.imageWhite;

          return (
            <div
              key={`${item.id}-${i}`} // Better key to prevent React reconciliation issues
              onClick={() => {
                if (type !== "retailer") {
                  handleSetMain(item.label);
                }
              }}
              className="d-flex flex-column align-items-center justify-content-center position-relative my-2"
              style={{
                height: "110px",
                width: "120px",
                backgroundColor: isMain ? "#E3C2A8" : "#000",
                borderRadius: "12px",
                margin: "0 auto",
                padding: "5px",
                cursor: "pointer",
              }}
            >
              <img
                src={image || item?.imageWhite || item?.image || NAIMAGE}
                alt={item?.label}
                style={{ maxHeight: "60px", width: "30px" }}
              />
              <h6
                className="text-white text-center mt-2"
                style={{ fontSize: "14px", fontWeight: 600 }}
              >
                {item?.label || item}
              </h6>
              <Button
                color="warning"
                size="sm"
                className="position-absolute"
                style={{
                  top: "-10px",
                  right: "-5px",
                  padding: "2px 6px",
                  fontSize: "12px",
                  borderRadius: "50%",
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent triggering the main div's onClick
                  _handleDelete(item.id);
                }}
              >
                ×
              </Button>
            </div>
          );
        })
      ) : (
        <div className="d-flex justify-content-center align-items-center mt-4 gap-2">
          <Spinner size="sm" color="primary" />
          <span style={{ fontSize: "14px", color: "#0D99FF" }}>Fetching</span>
        </div>
      )}
      {openDropDown ? (
        <DropDownSelectFromList
          data={getDropdownOptions(column.field)}
          isNested
          values={data}
          onValueSelect={_handleAdd}
        />
      ) : (
        <div className="mt-2">
          <Button
            size="sm"
            className="rounded-circle"
            style={{ backgroundColor: "#DCDCDC", border: "none" }}
            onClick={() => setOpenDropDown(true)}
          >
            +
          </Button>
        </div>
      )}
    </div>
  );
};

export default EditBrandFormFieldColumn;
